import { InformacionVisitaDetalle } from './../../shared/models/informacionVisitante.model';
import { InformacionVisitanteModel } from 'src/app/shared/models/informacionVisitante.model';
import { FuncionarioModel } from './../../models/funcionario.model';
import { AssetsService } from './../../shared/services/assets.service';
import { FuncionarioDependenciaModel } from './../../models/funcionarioDependencia.model';
import { UrlService } from './../../shared/services/url.service';
import { GlobalService } from './../../shared/global.service';
import { AgendaModel } from './../../models/agenda.model';
import { AlertService } from './../../shared/services/alert.service';
import { VisitaModel } from './../../models/visita.model';
import { ConfirmationModalOptions } from './../../shared/models/modal.model';
import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl } from '@angular/forms';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { DependenciaModel } from 'src/app/models/dependencia.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import * as moment from 'moment';
declare var $: any;

@Component({
  selector: 'app-modal-registrar-visita',
  templateUrl: './registrar-visita-modal.component.html',
  styleUrls: ['./registrar-visita-modal.component.scss']

})
export class ModalRegistrarVisitaComponent implements OnInit {

  @Input() public data: AgendaModel;
  @Input() public consultaInformacionVisitante: any;


  public fechaAgenda: string;
  public editarAgenda;
  public nuevaAgenda;
  public agendas: VisitaModel[];
  public modalOptions: ConfirmationModalOptions;
  public visitaModel: VisitaModel;
  public formValid;
  public alertMessage;
  public dependencias: DependenciaModel[];
  public consultaDependencia: any;
  public listaDependencias: any;
  public funcionarios: FuncionarioDependenciaModel[];
  public dependenciaSeleccionada: string;
  public HorasDelDia: any[];
  public fechaValida;
  public agendaEnEdicion: number;
  private fechaConsulta: any;
  public editar;
  public sedes: any;
  public agendaCancelar: InformacionVisitanteModel;
  public nombreFuncionarioEdicion;
  private msgAgendaRepetida = "Error no se puede crear agenda porque el visitante tiene una visita programadas para la misma fecha y hora";
  public modalOptionsCancelar: ConfirmationModalOptions;
  private agendaAnteriorEditar: VisitaModel;
  public dependencia: any;
  private horaInicial: string;
  private horaFinal: string;

  constructor(
    private alertService: AlertService, private modalService: NgbModal
    , private activeModal: NgbActiveModal, private global: GlobalService
    , private urlService: UrlService, private spinner: NgxSpinnerService) {

    this.nombreFuncionarioEdicion = null;
    this.fechaValida = false;
    this.editarAgenda = false;
    this.nuevaAgenda = false;
    this.formValid = false;
    this.alertMessage = '';
    this.agendaEnEdicion = null;
    this.editar = false;
    this.visitaModel = new VisitaModel(null, null, null, null, null, false, null, null, null, null);
    this.dependencias = [];
    this.sedes = [];
    this.fechaConsulta = '';
    this.agendas = [];
    this.funcionarios = [];
    this.HorasDelDia = [];

    // valida si no existe input de datos para el componente
    if (!this.data) {
      this.data = new AgendaModel('', '', '', '', '', null);
    }
    // opciones del modal de confirmación
    this.modalOptions =
      new ConfirmationModalOptions('Confirmación', '¿Está seguro de registrar agenda?',
        'SI', 'NO', 'far fa-clock', !this.formValid, false, 'Guardar Agenda', null, 'btn-secondary col-11');
    this.modalOptionsCancelar =
      new ConfirmationModalOptions('Confirmación', '¿Está seguro de cancelar la agenda?',
        'SI', 'NO', 'fas fa-trash', false, false, 'Cancelar Agenda', null, 'btn-danger');

  }

  ngOnInit() {
    const fechaAgendaTemp = new Date(this.data.fechaInicioAgendada + ' 00:00:00');
    this.agendas = [];
    this.agendas = this.data.visitas;

    if (this.agendas != null && this.agendas.length >= 1 && this.data.editar) {
      this.editar = true;
      this.convertirHora(this.agendas);
      this.fechaAgenda = this.obtenerFechaCabecera(fechaAgendaTemp);

    } else {
      this.editar = false;
      this.fechaAgenda = this.obtenerFechaCabecera(fechaAgendaTemp);
    }
    this.obtenerHoras();
    this.getAgendas();
    this.getSedes();
    this.getDependencias();
  }

  /**
   * Método que Consulta los dominios que se relacionen con el nombre 'EstadoCodigo'
   */
  public obtenerHoras() {
    this.spinner.show();
    const serviceProvider = 'ObtenerDominio';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'HorasAgenda']);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
    this.global.getGenerico(url).subscribe(
      data => {
        data = data.filter(detalle => detalle.estado === 1);
        this.generarTurnos(data);
        this.spinner.hide();
      }, err => {
        this.spinner.hide();
        this.cathException('No es posible obtener los estados', err);
      }
    );
  }

  generarTurnos(lista: DetalleDominio[]) {
    this.horaInicial = lista.find((detalle: DetalleDominio) =>
      detalle.detalleDominioPK.nombreDetalleDominio === 'HORA_INICIO').valor;
    this.horaFinal = lista.find((detalle: DetalleDominio) =>
      detalle.detalleDominioPK.nombreDetalleDominio === 'HORA_FIN').valor;
    let fechaInicial = new Date();
    fechaInicial.setHours(Number(this.horaInicial), 0, 0, 0);
    const fechaFinal = new Date();
    fechaFinal.setHours(Number(this.horaFinal), 0, 0, 0);
    while (fechaInicial <= fechaFinal) {
      const nuevaFecha = moment(fechaInicial);
      this.HorasDelDia.push(nuevaFecha.format('HH:mm'));
      fechaInicial = nuevaFecha.add(30, 'minutes').toDate();
    }
  }

  /**
   *
   */
  convertirHora(agendas: VisitaModel[]) {
    agendas.forEach(element => {
      element.nuevaAgenda = false;
      const hora = element.fechaInicioAgendada.split(' ');
      if (hora.length > 1) {
        const h = hora[1].split(':');
        if (h.length > 2) {
          element.horaInicioVisita = h[0] + ':' + h[1];
        } else {
          element.horaInicioVisita = hora[1];
        }
      }
      const hora2 = element.fechaFinAgendada.split(' ');
      if (hora2.length > 1) {
        const h = hora2[1].split(':');
        if (h.length > 2) {
          element.horaFinVisita = h[0] + ':' + h[1];
        } else {
          element.horaFinVisita = hora[1];
        }
      }
    });
  }


  /**
   * @author klagos
   * método para consumir el dominio de dependencias
   *  20/12/2019
   */
  getDependencias() {
    this.spinner.show();
    const serviceProvider = 'ObtenerDependencias';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null),
      this.urlService.hostAPI_ACCVIS);
    this.global.getGenerico(url).subscribe(
      data => {
        this.consultaDependencia = data;
        if (this.visitaModel.dependencia) {
          this.listaDependencias = data;
        }
        this.spinner.hide();
      }, err => {
        // this.cacthException('No es posible Obtener las dependencias');
      }
    );
  }

  // fromero
  // método para consultar las sedes
  // 30/05/2019
  getSedes() {
    const serviceProvider = 'ObtenerDominio';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'Sede']);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
    this.global.getGenerico(url).subscribe(
      data => {
        this.sedes = data;
        this.spinner.hide();
      }, err => {
        this.cathException('No es posible cargar las Sedes', err);
      }
    );
  }

  // fromero
  // método para consultar los funcionarios por dependencia y sede
  // 29/04/2019
  getFuncionariosDependencia(editar?) {
    if (!isNaN(this.visitaModel.dependencia) && this.visitaModel.dependencia != null) {
      if (this.visitaModel.sede != '' && this.visitaModel.sede) {
        this.spinner.show();
        const serviceProvider = 'ObtenerFuncionario';
        // const pathParams: Array<[number, string]> = null;
        const pathParams: Array<[string, string]> = new Array<[string, string]>();
        pathParams.push(['filterBy=idDependencia', this.urlService.encodeURI(this.visitaModel.dependencia)]);
        pathParams.push(['sede', this.urlService.encodeURI(this.visitaModel.sede)]);
        let url = this.urlService.getUrl(new UrlControl(serviceProvider, pathParams, null), this.urlService.hostAPI_ACCVIS);
        url = url.concat('&orderBy=nombreCompleto$ASC');

        this.global.getGenerico(url).subscribe(
          (data: any[]) => {
            this.funcionarios = data;
            this.validarHoras();

            if (editar) {
              this.editarAgenda = true;
            } else {
              this.nombreFuncionarioEdicion = null;
              this.visitaModel.aQuienVisita = null;
            }
            this.spinner.hide();
            this.setFuncionarioEdicion();
          }, err => {
            this.cathException('No es posible cargar los funcionarios', err);
          }
        );
      }
    }

  }

  // fromero
  // método para consumir las agendas del día para el funcionario seleccionado
  // 29/04/2019
  getAgendas() {
    this.getDependencias();
  }


  /**
   * 30/04/2019
   * Handler de confirmaciòn cancelar
   * @param event 
   * @param agendaCancelar 
   * @param agenda 
   * @author fromero
   */
  confirmacionCancelar(event, agendaCancelar, agenda) {
    if (event[0] === true) {
      if (this.editar && !agenda.nuevaAgenda) {
        this.onCancelarAgenda(agenda, agendaCancelar);
      } else {
        this.agendas.splice(agendaCancelar, 1);
        this.alertService.generateAlertSuccess('La agenda se ha cancelado exitosamente', 'Agenda Cancelada');
      }

    }
  }

  // fromero
  // método para cerrar el modal activo y envíar lista de visitas a formulario de agenda
  // 26/04/2019
  close() {
    this.activeModal.close({ listaVisitas: this.agendas });

    // emite la lista de agendas que se ingresaron en el modal
  }

  // fromero
  // handler del modal de confirmación para guardar o editar agenda, se llaman los
  // metodos de validaciones de formularios y traslap de horas
  // 26/04/2019
  getConfirmationModalResponse(event) {
    if (event[0] === true) {
      if (!this.editar) {
        this.spinner.show();
        this.visitaModel.fechaInicioAgendada = this.data.fechaInicioAgendada;
        this.visitaModel.numeroDocumentoVisitante = this.data.numeroDocumentoUsuario;
        this.visitaModel.tipoDocumentoVisitante = this.data.tipoDocumentoUsuario;
        this.visitaModel.nombreVisitante = this.data.nombreUsuario;
        this.visitaModel.primerNombre = this.data.primerNombre;
        this.visitaModel.segundoNombre = this.data.segundoNombre;
        this.visitaModel.primerApellido = this.data.primerApellido;
        this.visitaModel.segundoApellido = this.data.segundoApellido;
        const queryParams: Array<[string, string]> = new Array<[string, string]>();

        const serviceProvider = 'ValidarAgenda';
        const fecha = this.visitaModel.fechaInicioAgendada + ' ' + this.visitaModel.horaInicioVisita + ':00';
        queryParams.push(['fechaInicioAgenda', fecha]);
        queryParams.push(['idVisitante', this.visitaModel.numeroDocumentoVisitante]);
        queryParams.push(['idFuncionario', this.visitaModel.aQuienVisita.numeroIdFuncionario]);
        queryParams.push(['tipoIdVisitante', this.visitaModel.tipoDocumentoVisitante]);
        queryParams.push(['tipoIdFuncionario', this.visitaModel.aQuienVisita.tipoIdFuncionario]);
        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
        this.global.getGenerico(url).subscribe(
          data => {
            let validacionTemp = false;
            validacionTemp = this.validarAgendasCruzadas(validacionTemp);

            if (!validacionTemp) {
              if (this.agendaEnEdicion != null) { // valida la agenda que se edito
                this.agendas.splice(this.agendaEnEdicion, 1); // la elimina del arreglo actual
              }

              this.visitaModel.nuevaAgenda = true;
              this.agendas.push(this.visitaModel); // ingresa la nueva agenda
              // se reinicia el modelo de visita, para editar una nueva.

              this.ordenarListaAgendas();

              this.visitaModel = new VisitaModel(null, null, null, null, null, false, null, null, null, null);
              this.nuevaAgenda = false;
              this.editarAgenda = false;
              this.agendaEnEdicion = null;
              this.validarFormulario(); // se reinicia el formulario
              this.alertService.generateAlertSuccess('La agenda se ha creado exitosamente', 'Agenda Creada');
              this.funcionarios = [];
              this.nombreFuncionarioEdicion = null;
              this.spinner.hide();
            } else {
              this.alertService.generateAlertError('Error no se puede crear agenda porque el visitante tiene una visita programadas para la misma fecha y hora', '');
              this.spinner.hide();
            }
          }, err => {
            this.cathException(err.error.message, '');
          }
        );
      }
      else {
        this.editarAgendaIndividual(this.agendaAnteriorEditar, this.visitaModel);
      }
    }
  }


  /**
   * valida que no hayan agendas cruzadas
   * @param validacionTemp 
   * @author fromero
   */
  validarAgendasCruzadas(validacionTemp) {
    var arrayTempAgendas = this.agendas.slice();
    if (this.agendaEnEdicion != null) { // valida la agenda que se edito
      arrayTempAgendas.splice(this.agendaEnEdicion, 1); // la elimina del arreglo actual
    }
    arrayTempAgendas.forEach(element => {
      let horaInicio = parseFloat(this.visitaModel.horaInicioVisita.replace(':', '.'));
      let horaFin = parseFloat(this.visitaModel.horaFinVisita.replace(':', '.'));
      let horaChek = parseFloat(element.horaInicioVisita.replace(':', '.'));
      let horaCheck2 = parseFloat(element.horaFinVisita.replace(':', '.'));
      if (horaInicio >= horaChek && horaCheck2 > horaInicio) {
        validacionTemp = true;
      } else if (horaInicio < horaChek && horaFin < horaCheck2 && horaFin > horaChek) {
        validacionTemp = true;
      } else if (horaInicio > horaChek && horaFin > horaCheck2 && horaInicio < horaCheck2) {
        validacionTemp = true;
      } else if (horaInicio < horaChek && horaFin > horaCheck2) {
        validacionTemp = true;
      }
    });
    return validacionTemp;
  }

  /**
   * 
   */
  onNuevaAgenda() {
    this.nuevaAgenda = true;
    this.validarFormulario();
  }


  /**
   * fromero
   *  metodo para setear el modelo de edición de agenda en el formulario
   *  30/04/2019
   * @param agenda
   * @param i
   */
  onEditarAgenda(agenda: VisitaModel, i) {

    this.agendaAnteriorEditar = agenda;
    if (!isNaN(agenda.dependencia)) {
      this.visitaModel.dependencia = agenda.dependencia;
    } else {
      // tslint:disable-next-line: radix
      this.visitaModel.dependencia = parseInt(agenda.idDependecia);
    }
    this.visitaModel.aQuienVisita = agenda.aQuienVisita;
    this.visitaModel.sede = agenda.sede;
    this.getFuncionariosDependencia('editar');

    this.visitaModel.fechaFinAgendada = agenda.fechaFinAgendada;
    this.visitaModel.fechaInicioAgendada = agenda.fechaInicioAgendada;
    this.visitaModel.horaFinVisita = agenda.horaFinVisita;
    this.visitaModel.horaInicioVisita = agenda.horaInicioVisita;
    this.visitaModel.nombreVisitante = agenda.nombreVisitante;
    this.visitaModel.primerNombre = agenda.primerNombre;
    this.visitaModel.segundoNombre = agenda.segundoNombre;
    this.visitaModel.primerApellido = agenda.primerApellido;
    this.visitaModel.segundoApellido = agenda.segundoApellido;
    this.visitaModel.numeroDocumentoUsuarioAnterior = agenda.numeroDocumentoUsuarioAnterior;
    this.visitaModel.numeroDocumentoVisitante = agenda.numeroDocumentoVisitante;
    this.visitaModel.tipoDocumentoUsuarioAnterior = agenda.tipoDocumentoUsuarioAnterior;
    this.visitaModel.tipoDocumentoVisitante = agenda.tipoDocumentoVisitante;
    this.visitaModel.todoElDia = agenda.todoElDia;

    this.filtrarDependencias();
    this.agendaEnEdicion = i;
    this.spinner.hide();

  }

  // fromero
  // mètodo para cancelar una agenda exitente
  // 30/04/2019
  onCancelarAgenda(agenda: VisitaModel, agendaEliminar) {

    this.spinner.show();
    const agendasActualizadas: InformacionVisitaDetalle[] = [];

    const agendaEdicion = new InformacionVisitaDetalle(
      agenda.fechaInicioAgendada
      , null
      , agenda.dependencia
      , null
      , null
      , agenda.fechaInicioAgendada
      , agenda.numeroDocumentoVisitante
      , agenda.aQuienVisita.numeroIdFuncionario
      , this.consultaInformacionVisitante.visitas[0].tipoDocumentoVisitante
      , agenda.aQuienVisita.tipoIdFuncionario
      , null
      , null
      , agenda.sede);

    agendasActualizadas.push(agendaEdicion);
    this.agendaCancelar = new InformacionVisitanteModel('', '', '', '', '', false, '', '', '', false, '', [], '');

    this.agendaCancelar.correoElectronico = this.data.correo;
    this.agendaCancelar.empresa = this.data.empresa;
    this.agendaCancelar.listaVisitas = agendasActualizadas;
    this.agendaCancelar.tipoDocumento = this.data.tipoDocumentoUsuario;
    this.agendaCancelar.numeroDocumento = this.data.numeroDocumentoUsuario;
    this.agendaCancelar.tipoDocumento = this.consultaInformacionVisitante.visitas[0].tipoDocumentoVisitante;
    this.agendaCancelar.nombreCompleto = this.consultaInformacionVisitante.nombreUsuario;
    this.agendaCancelar.primerNombre = this.consultaInformacionVisitante.primerNombre;
    this.agendaCancelar.segundoNombre = this.consultaInformacionVisitante.segundoNombre;
    this.agendaCancelar.primerApellido = this.consultaInformacionVisitante.primerApellido;
    this.agendaCancelar.segundoApellido = this.consultaInformacionVisitante.segundoApellido;
    this.agendaCancelar.tipoIdPreautorizador = sessionStorage.getItem('tipoDocumento');
    this.agendaCancelar.numIdPreautorizador = sessionStorage.getItem('numDocumento');
    this.agendaCancelar.sede = agenda.sede;

    const serviceProvider = 'cancelarAgenda';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);

    this.global.postGenerico(url, this.agendaCancelar).subscribe(
      data => {
        this.agendas.splice(agendaEliminar, 1);
        this.alertService.generateAlertSuccess('La agenda se ha cancelado exitosamente', 'Agenda Cancelada');
        this.spinner.hide();
      }, err => {
        this.cathException(err.error.message, '');

      }
    );

  }

  // fromero
  // Action del boton de cancelar una ediciòn de formulario
  // 30/04/2019
  cancelar() {
    this.visitaModel = new VisitaModel(null, null, null, null, null, false, null, null, null, null);
    this.nuevaAgenda = false;
    this.editarAgenda = false;
    document.getElementById('btnCerrarModalAgenda').focus();
    this.funcionarios = [];
    this.nombreFuncionarioEdicion = null;
    this.agendaEnEdicion = null;
  }

  // fromero
  // Método para obtener la fecha en formato de texto
  // 24/04/2019
  obtenerFechaCabecera(fecha) {
    const meses = AssetsService.MESES;

    const fechaActual = fecha;
    const diaTemp = (fechaActual.getDate()).toString();

    const mes = meses[fechaActual.getMonth()];
    const año = fechaActual.getFullYear().toString();
    return diaTemp + ' ' + mes + ' DE ' + año;
  }

  // fromero
  // valida completitud del formulario para habilitar el boton de confirmación
  // 29/04/2019
  public validarFormulario() {

    if (
      (
        (this.visitaModel.horaInicioVisita !== ''
          && this.visitaModel.horaFinVisita !== ''
        ) || this.visitaModel.todoElDia === true
      )
      && this.visitaModel.dependencia != null &&
      this.visitaModel.aQuienVisita != null && this.fechaValida) {
      this.formValid = true;
      this.modalOptions.disabled = false;
    } else {
      this.formValid = false;
      this.modalOptions.disabled = true;
    }
  }

  // fromero
  // método para activar la opción todo el día
  // 29/04/2019
  setTodoElDia() {
    this.visitaModel.todoElDia = !this.visitaModel.todoElDia;
    this.visitaModel.horaInicioVisita = (Number(this.horaInicial) > 9 ? this.horaInicial : '0' + this.horaInicial) + ':00';
    this.visitaModel.horaFinVisita = (Number(this.horaFinal) > 9 ? this.horaFinal : '0' + this.horaFinal) + ':00';
    this.fechaValida = true;
  }

  // fromero
  // handler de excepción de consumo de servicios
  // 29/04/2019
  cathException(error, err) {
    this.alertService.generateAlertError(error, 'Error');
    this.spinner.hide();
  }

  // fromero
  // método para validar que hora inicio no sea mayor a hora fin
  // 30/04/2019
  validarHoras() {
    var hora1 = null;
    var hora2 = null;

    if (this.visitaModel.horaInicioVisita && this.visitaModel.horaFinVisita) {
      hora1 = this.visitaModel.horaInicioVisita.split(':');
      hora2 = this.visitaModel.horaFinVisita.split(':');

      // tslint:disable-next-line: radix
      const number11 = parseInt(hora1[0].split(':')[0]);
      // tslint:disable-next-line: radix
      const number12 = parseInt(hora1[1]);
      // tslint:disable-next-line: radix
      const number21 = parseInt(hora2[0].split(':')[0]);
      // tslint:disable-next-line: radix
      const number22 = parseInt(hora2[1]);



      if (number11 == number21 && number12 == number22) {
        this.fechaValida = false;
        this.alertService.generateAlertError('Hora Inicio es mayor o igual a Hora fin ', 'Horas Invalidas');
      } else {
        if (hora1.length >= 2 && hora2.length >= 2) {
          if (number11 <= number21) {
            if (number12 <= number22) {
              this.fechaValida = true;
            } else {
              if (number11 < number21) {
                this.fechaValida = true;
              } else {
                this.fechaValida = false;
                this.alertService.generateAlertError('Hora Inicio es mayor o igual a Hora fin ', 'Horas Invalidas');
              }
            }
          } else {
            this.fechaValida = false;
            this.alertService.generateAlertError('Hora Inicio es mayor o igual a Hora fin ', 'Horas Invalidas');
          }
        }
      }

      //la siguiente validación es para verificar
      // que la hora de final no esté antes de la hora actual del sistema

      // A variable of type Date is constructed with the selected Date of "fecha de agendamiento" and 
      // the hour of the field "hora fin formulario", this variable represents the full date of 
      // the end date of scheduling

      let fechaFinalAgendamiento = new Date(this.data.fechaInicioAgendada + ' 00:00:00');
      fechaFinalAgendamiento.setHours(number21, number22);

      let fechaActual = new Date();

      let isSameYear = moment(fechaActual).isSame(moment(this.data.fechaInicioAgendada), 'year');
      let isSameMonth = moment(fechaActual).isSame(moment(this.data.fechaInicioAgendada), 'month');
      let isSameDay = moment(fechaActual).isSame(moment(this.data.fechaInicioAgendada), 'day');

      //Si la fecha de agendamiento es la misma fecha del formulario hace la validación 
      if (isSameYear && isSameMonth && isSameDay) {
        let isAfter = moment(fechaActual).isAfter(fechaFinalAgendamiento);
        if (isAfter) {
          this.fechaValida = false;
          this.alertService.generateAlertError('La hora final no puede estar antes de la hora actual', 'Horas Invalidas');
        }
      }
    }
    this.validarFormulario();
  }

  // fromero
  // 28/05/2019
  // consulta de Agendas para edición
  consultarAgendasEdicion() {
    this.spinner.show();
    const serviceProvider = 'ObetenerInformacionAgendasVisitante';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();

    queryParams.push(['tipoDocumento', this.data.tipoDocumentoUsuario]);
    queryParams.push(['numeroDocumento', this.data.numeroDocumentoUsuario]);
    queryParams.push(['fechaConsulta', this.fechaConsulta]);


    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);

    this.global.postGenerico(url).subscribe(
      data => {
        if (data.length > 0) {
          const obj: InformacionVisitanteModel = data[0];

          this.agendas = [];
          obj.listaVisitas.forEach(element => {

            const agendaTemp = new VisitaModel(element.fecha_Inicial_Agendada
              , element.fecha_Inicial_Agendada
              , element.fecha_Inicial_Agendada
              , element.dependencia
              , new FuncionarioModel(element.numero_Id_Funcionario, element.tipo_Id_Funcionario)
              , false
              , obj.nombreCompleto
              , obj.tipoDocumento
              , element.num_Doc_Visitante
              , obj.primerNombre
              , obj.segundoNombre
              , obj.primerApellido
              , obj.segundoApellido
            );

            this.agendas.push(agendaTemp);

            this.spinner.hide();
          });
        } else {
          this.spinner.hide();
        }

      }, err => {
        this.cathException(err, err);
      }
    );
  }

  setFuncionario(event) { }

  /**
   * setea el funcionario para mostrar en la ediciòn de la agenda
   */
  setFuncionarioEdicion() {
    if (this.editarAgenda && this.visitaModel.aQuienVisita) {
      const e = this.funcionarios.find(el => {
        return el.funcionarioPK.numeroIdFuncionario === this.visitaModel.aQuienVisita.numeroIdFuncionario
          && el.funcionarioPK.tipoIdFuncionario === this.visitaModel.aQuienVisita.tipoIdFuncionario;
      });
      if (e) {
        this.nombreFuncionarioEdicion = e.nombreCompleto;
      }
    }
    this.validarFormulario();
  }


  /**
   * 
   */
  elimiinarFuncionarioEdicion() {
    this.nombreFuncionarioEdicion = null;
    this.visitaModel.aQuienVisita = null;
    setTimeout(() => {
      document.getElementById('aQuienVisita').focus();
      $('#aQuienVisita').trigger('click');
    }, 100);
    this.validarFormulario();
  }

  /**
   * ordena las agendas de menor a mayor por horas
   * @author fromero
   */
  ordenarListaAgendas() {
    this.agendas.sort(
      function (a, b) {
        if (a.horaInicioVisita > b.horaInicioVisita) {
          return 1;
        }
        if (a.horaInicioVisita < b.horaInicioVisita) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });
  }


  /**
   * mètodo para editar una agenda especìfica
   * @param agendaAnterior 
   * @param nuevaAgenda 
   * @author fromero
   */
  public editarAgendaIndividual(agendaAnterior, nuevaAgenda) {
    this.spinner.show();
    var validacionTemp = false;
    validacionTemp = this.validarAgendasCruzadas(validacionTemp);

    if (!validacionTemp) {

      this.construirObjetosEditarAgendaindividual(agendaAnterior, nuevaAgenda);
    } else {
      this.alertService.generateAlertError('Error no se puede crear agenda porque el visitante tiene una visita programadas para la misma fecha y hora', '');
      this.spinner.hide();
    }
  }

  /**
   * arma el objeto que se envía al backend para la petición
   * @param agendaAnterior
   * @param nuevaAgenda
   */
  private construirObjetosEditarAgendaindividual(agendaAnterior: VisitaModel, nuevaAgenda: VisitaModel) {

    this.reemplazarHorasEdicion(nuevaAgenda);
    var agenda = new AgendaModel(
      this.consultaInformacionVisitante.correo,
      this.consultaInformacionVisitante.empresa,
      this.consultaInformacionVisitante.nombreCompleto,
      this.consultaInformacionVisitante.numeroDocumentoUsuario,
      this.consultaInformacionVisitante.tipoDocumentoUsuario,
      [],
      null,
      this.consultaInformacionVisitante.fechaInicioAgendada,
      this.consultaInformacionVisitante.placa,
      this.consultaInformacionVisitante.otro,
      this.consultaInformacionVisitante.tipoVehiculo,
      sessionStorage.getItem('numDocumento'),
      sessionStorage.getItem('tipoDocumento'),
      null,
      true
    );

    nuevaAgenda.tipoDocumentoVisitante = this.consultaInformacionVisitante.tipoDocumentoUsuario;
    nuevaAgenda.numeroDocumentoVisitante = this.consultaInformacionVisitante.numeroDocumentoUsuario;
    if (agendaAnterior) {
      agendaAnterior.numeroDocumentoVisitante = this.consultaInformacionVisitante.numeroDocumentoUsuario;
      agendaAnterior.tipoDocumentoVisitante = this.consultaInformacionVisitante.tipoDocumentoUsuario;
      agenda.visitas.push(agendaAnterior);
    }
    agenda.visitas.push(nuevaAgenda);
    const serviceProvider = 'editarAgendaIndividual';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
    agenda.numeroDocumentoUsuarioAutorizador = sessionStorage.getItem('numDocumento');
    agenda.tipoDocumentoUsuarioAutorizador = sessionStorage.getItem('tipoDocumento');

    this.global.postGenerico(url, agenda).subscribe(
      data => {
        if (this.agendaEnEdicion != null) { // valida la agenda que se edito
          this.agendas.splice(this.agendaEnEdicion, 1); // la elimina del arreglo actual
        }
        this.visitaModel.nuevaAgenda = true;
        this.agendas.push(nuevaAgenda); // ingresa la nueva agenda
        this.ordenarListaAgendas();
        this.visitaModel = new VisitaModel(null, null, null, null, null, false, null, null, null, null);
        this.nuevaAgenda = false;
        this.editarAgenda = false;
        this.agendaEnEdicion = null;
        this.validarFormulario(); // se reinicia el formulario
        this.alertService.generateAlertSuccess('La agenda se ha creado exitosamente', 'Agenda Creada');
        this.funcionarios = [];
        this.nombreFuncionarioEdicion = null;
        this.spinner.hide();
      }, err => {
        this.cathException(err.error.message, '');
      }
    );
  }


  reemplazarHorasEdicion(nuevaAgenda: VisitaModel) {
    if (nuevaAgenda.fechaInicioAgendada && nuevaAgenda.fechaFinAgendada) {
      var f1 = nuevaAgenda.fechaInicioAgendada.split(' ');
      var f2 = nuevaAgenda.fechaFinAgendada.split(' ');
      f1[1] = nuevaAgenda.horaInicioVisita + ':00';
      f2[1] = nuevaAgenda.horaFinVisita + ':00';
      nuevaAgenda.fechaInicioAgendada = f1[0] + ' ' + f1[1];
      nuevaAgenda.fechaFinAgendada = f2[0] + ' ' + f2[1];
      return true;
    } else {
      nuevaAgenda.fechaInicioAgendada = this.consultaInformacionVisitante.fechaInicioAgendada + ' ' + nuevaAgenda.horaInicioVisita + ':00';
      nuevaAgenda.fechaFinAgendada = this.consultaInformacionVisitante.fechaInicioAgendada + ' ' + nuevaAgenda.horaFinVisita + ':00';

    }
  }

  /**
     * Metodo que filtra las dependencias por sede
     * @author klagos@asesoftware.com
     */
  filtrarDependencias() {
    this.listaDependencias = this.consultaDependencia.filter(dep => dep.sede ===
      this.visitaModel.sede);
  }

}
